// extracted by mini-css-extract-plugin
export default {"urgentDC_PopUp":"UrgentDCModal_urgentDC_PopUp__fnDOY","urgentDC_PopUp_Container":"UrgentDCModal_urgentDC_PopUp_Container__Mdgdb","closeBtn":"UrgentDCModal_closeBtn__vNYVu"};